import { Injectable } from '@angular/core';
import { PasFeature } from '@ddt-web/data-service';
import { AssetResolveResponse, PasPortfolioPosition } from '@ddt-web/pas';
import { Store } from '@ngrx/store';

import { positionDetailsCompareLoaded, positionDetailsLoaded, taxDetailsLoaded } from '../../../store/data-loading.actions';
import { PasPostProcessingService } from './pas-post-processing.service';

/**
 * Service that processes the WWE store dispatch with positionDetailsLoaded action for security-details API response for IQ.
 */
@Injectable()
export class PasPositionDetailsLoadedProcessingService extends PasPostProcessingService {

	constructor(private store: Store) {
		super();
	}

	public process(portfoliosToLoad: PasPortfolioPosition[], filteredIds?: string[], positionDataFromApiCall?: AssetResolveResponse, feature?: PasFeature): void {
		if (feature === PasFeature.COMPARE) {
			this.store.dispatch(positionDetailsCompareLoaded({ payload: portfoliosToLoad }));
		} else if (feature === PasFeature.WORST_TAX_OFFENDERS) {
			this.store.dispatch(taxDetailsLoaded({ payload: portfoliosToLoad }));
		} else {
			this.store.dispatch(positionDetailsLoaded({ payload: portfoliosToLoad }));
		}
	}
}
